var SocialShortcutPanels = {
  init: function() {
    this.setVariables();

    this.$links.each(this.updateHref);
  },
  setVariables: function() {
    this.$links = $(".shortcut-panel__link");
  },
  updateHref: function() {
    var $this = $(this);
    var action = $this.data("action");
    var detail = $this.data("detail");

    var url = Config.contextPath + "/" + Config.portalInterface + "/";

    if (action == "search") {
      url = RA.buildSearchUrl(detail);
    } else if (action == "browse") {
      url += "?tabid=" + Config.resultsTabID + "&taxonomypath=" + encodeURIComponent(detail) + "#t=kbResults";
    } else if (action == "community") {
      if (Config.isCommunityEnabled) {
        url += "?tabname=community&communityID=" + detail;
      } else {
        url = "#";
        $this.parent().hide();
      }
    } else if (action == "url") {
	  url = detail+"";//append blank in case the detail is a number we need to convert to string.
	  if (url.indexOf('new_window-') === 0) {
		  $this.attr("target", "_blank");
		  url = url.substr(url.indexOf("new_window-") + 11);
		  $this.data("detail", url);
	  }
    }

    $this.attr("href", url);
  }
};
